export const EMPLOYEE_DETAILS_FETCH_DATA = 'EMPLOYEE_DETAILS_FETCH_DATA';
export const EMPLOYEE_DETAILS_FETCH_DATA_SUCCESS = 'EMPLOYEE_DETAILS_FETCH_DATA_SUCCESS';
export const EMPLOYEE_DETAILS_FETCH_DATA_ERROR = 'EMPLOYEE_DETAILS_FETCH_DATA_ERROR';
export const EMPLOYEE_DETAILS_DATA_CLEAN_STATE = 'EMPLOYEE_DETAILS_DATA_CLEAN_STATE';

export const EMPLOYEE_DETAILS_UPDATE_DATA = 'EMPLOYEE_DETAILS_UPDATE_DATA';